module.exports = __webpack_public_path__ + "img/belun.98e58934.png";